import React, { Component, PropTypes } from 'react';

import { camelizeKeys } from 'humps';
import { callApi } from '../../../middleware/api';

import Loader from '../../../components/Loader';
import { formatDateTime } from '../../../utils/date';

export default class Reservations extends Component {
  static contextTypes = {
    company: PropTypes.object.isRequired
  };

  state = {
    companyId: null,
    loading: true,
    items: null
  };

  loadOrders = (companyId) => {
    callApi(`orders/${companyId}/`)
      .then(
        ({results}) => {
          this.setState({
            loading: false,
            companyId,
            items: camelizeKeys(results)
          });
        },
        error => alert("Kļūda")
      );
  };

  componentWillMount() {
    const { company: {id} } = this.context;
    this.loadOrders(id);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextContext.company.id !== this.state.companyId) {
      this.loadOrders(nextContext.company.id);
    }
  }

  render() {
    const { items, loading } = this.state;
    return (
      <div className="container mt-5">
        <h1 className="mb-5">Pasūtījumi <small className="text-muted">pēdējo 12 mēnešu laikā</small></h1>
        <Loader loaded={!loading}>
          {!loading && (
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Nosaukums</th>
                  <th>Pasūtījums no</th>
                  <th>Reklāma</th>
                  <th className="text-sm-right">Summa, &euro;</th>
                </tr>
              </thead>
              <tbody>
                {items.map(({campaignName, submittedAt, rows, sum}, idx) => 
                  <tr key={idx}>
                    <td>{campaignName}</td>
                    <td>{formatDateTime(submittedAt)}</td>
                    <td>
                      {rows.map(({ status: {label, style}, product, period, periodUnits }, idx) => 
                        <div className="row" key={idx}>
                          <div className="col-6">
                            {product} <span className="float-right text-muted">{periodUnits}</span>
                          </div>
                          <div className="col-6">
                            {period} <span className="badge float-right" style={style}>{label}</span>
                          </div>
                        </div>
                      )}
                    </td>
                    <td className="text-sm-right">{sum}</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </Loader>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Profile/Orders/index.js